__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/5f9448d/_next/";